export const ADD_ACTIVE_TRADE_ITEM = 'ADD_ACTIVE_TRADE_ITEM'
export const DELETE_TRADE_ITEM = 'DELETE_TRADE_ITEM'
export const DELETE_ACTIVE_TRADE_ITEM = 'DELETE_ACTIVE_TRADE_ITEM'
export const SET_ACTIVE_TRADE_ITEM = 'SET_ACTIVE_TRADE_ITEM'
export const DELETE_ALL_TRADES = 'DELETE_ALL_TRADES'
